var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ns-topnav-image-overlay-container" }, [
    _c("img", {
      staticClass: "topnav-image",
      attrs: { src: _vm.localSrc, alt: _vm.alt, width: "340", height: "100%" }
    }),
    _vm._v(" "),
    _vm.localSrc && _vm.overlayText
      ? _c("div", { staticClass: "image-overlay-text" }, [
          _vm._v("\n    " + _vm._s(_vm.overlayText) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }